import React from 'react'
import { Form } from 'react-bootstrap'
import { type CrossClientQueryResultCellProps } from './types'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { selectCrossClientSelectedResultIds, toggleCrossClientResultSelection } from '../../../../store/crossClient/crossClientResults'
import styles from './CrossClientResultSelect.module.scss'

export const CrossClientQueryResultSelectCell: React.FC<CrossClientQueryResultCellProps> = ({ result }) => {
  const dispatch = useAppDispatch()
  const selectedResultIds = useAppSelector(selectCrossClientSelectedResultIds)
  const checked = selectedResultIds.includes(result.id)
  const disabled = !!result.activeEvaluationId

  return (
    <div className={`d-flex justify-content-center align-items-center w-100 ${styles.checkbox}`}>
      <Form.Check
        type='checkbox'
        aria-label='Select row'
        checked={checked}
        disabled={disabled}
        onChange={() => dispatch(toggleCrossClientResultSelection(result.id))}
      />
    </div>
  )
}
